"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DecorateChildren;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function DecorateChildren(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var ChildrenWithClass = function ChildrenWithClass() {
    return _react["default"].Children.map(children, function (child) {
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        className: "".concat(child.props.className, " ").concat(className)
      });
    });
  };
  return /*#__PURE__*/_react["default"].createElement(ChildrenWithClass, null);
}
DecorateChildren.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  className: _propTypes["default"].string.isRequired
};